<template lang="pug">
  .product-container
    .product-header
      .product-title {{ $t('Rimix - 营销投资管理平台') }}
      .product-desc Rimix通过采购流程数字化、完备的项目数据存储记录及标准的供应商管理体系，帮助企业实现采购流程<br>透明合规可追溯，大幅节约采购成本。Rimix已为包括联合利华，滴滴出行等多家广告主提供服务，<br>平均可为客户节约采购成本30%。
      el-button.product-link(
        @click="onApplyAccount"
      ) {{ $t('申请Demo账号') }}
      .product-img
        img(
          src="@/assets/libra-4.png"
        )
    .product-content-container
      .product-content-item
        img(
          src="@/assets/libra-1.png"
        )
        .product-content-desc.product-content-desc__ml
          .desc-title {{ $t('渠道整合') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('流程标准化数字化') }}
          .desc {{ $t('标准化的营销采购管理流程，涵盖需求下发，供应商竞标，合同管理，投放效果管理等采购流程各大阶段。通过采购流程数字化，提升企业协作效率，促进采购流程透明合规化，帮助企业降低采购成本。') }}

          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('流程灵活可配置') }}
          .desc {{ $t('Rimix后台支持流程，角色，权限的灵活配置。可根据企业实际需求实现高度定制化的流程设置。') }}
      .product-content-item
        .product-content-desc.product-content-desc__mr
          .desc-title {{ $t('数据记录') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('数据集中管理') }}
          .desc {{ $t('通过采购流程数字化实现营销采购数据的集中管理，全面及时掌握营销投入和产出数据。为企业分析，优化采购策略提供有效的依据。') }}

          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('全面丰富的报告') }}
          .desc {{ $t('Rimix报告模块内置项目报告，月度季度报告，供应商报告等丰富全面的报告模板，可随时根据各部门需求导出相关报告，同时支持自定义报告，便于企业进行各维度的统计分析。') }}
        img(
          src="@/assets/libra-2.png"
          )
      .product-content-item
        img(
          src="@/assets/libra-3.png"
        )
        .product-content-desc.product-content-desc__ml
          .desc-title {{ $t('供应商管理') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('标准的供应商管理体系') }}
          .desc {{ $t('建立企业一方供应商库，提供标准的入库流程和供应商评价机制，实现供应商信息在各部门，品牌间的共享。同时对接外部工商征信系统，为企业选择供应商提供更多更有价值的信息。') }}

          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('第三方供应商库') }}
          .desc {{ $t('依托贵了么营销资源平台，为企业提供更多供应商及媒体资源信息，方便企业获取更优质的供应商。') }}

    section#clients-say
      div.clients-say__content
        img(
          alt="what our clients say"
          src="@/assets/clients-say-logo_1.png"
          style="width: auto"
        )
        div
          ul.clients-say__case__content
            li(:class="{'active': activeIndex === 0}")
              p {{ $t('复歌科技通过Rimix营销采购管理平台助力联合利华优化外部供应商资源和提升内部协作效率，并受邀参加2019年戛纳国际创意节主题演讲。Rimix帮助企业实现更优质的供应商流程、更具优势的资源价格、更透明合规的流程管理、更快速的跨部门流程推进。') }}
          //- ul.clients-say__case__avators.f.f-sa
          //-   li(
          //-     :class="{'active_li': activeIndex === 0}"
          //-     @mouseover="activeIndex = 0"
          //-   )
          //-     div
          //-       img(
          //-         alt="avator"
          //-         src="@/assets/libra-avator.png"
          //-       )
          //-     p
          //-       | Kerloon Ang
          //-       br
          //-       span
          //-         | General Manager,
          //-         br
          //-         | Publicis Media Exchange
          //-   li(
          //-     :class="{'active_li': activeIndex === 1}"
          //-     @mouseover="activeIndex = 1"
          //-   )
          //-     div
          //-       img(
          //-         alt="avator"
          //-         src="@/assets/libra-avator.png"
          //-       )
          //-     p
          //-       | Andy
          //-       br
          //-       | CEO RTBAsia
          //-   li(
          //-     :class="{'active_li': activeIndex === 2}"
          //-     @mouseover="activeIndex = 2"
          //-   )
          //-     div
          //-       img(
          //-         alt="avator"
          //-         src="@/assets/libra-avator.png"
          //-       )
          //-     p
          //-       | Elvis Xu
          //-       br
          //-       span
          //-         | Managing Director, Search,
          //-         br
          //-         | GroupM

    contact
</template>

<script>
import PageFooter from '@/components/PageFooter'
import Contact from '@/components/Contact'
export default {
  components: {
    PageFooter,
    Contact
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  methods: {
    onApplyAccount () {
      this.$router.push('/contact?redirectUrl=/product/rimix&buttonName=申请Demo账号')
    }
  }
}
</script>
